<nz-spin [nzSpinning]="isLoading">
    <form nz-form [formGroup]="form">
        <nz-form-item>
            <nz-form-control nzErrorTip="Please input time range correctly!">
                <nz-range-picker formControlName="range_date"></nz-range-picker>
            </nz-form-control>
        </nz-form-item>
    </form>
</nz-spin>